import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as queryString from 'query-string';
import ErrorPage from './ErrorPage';
import GetCategoriesQuery from '../components/Query/Categories';
import ProductList from '../components/ProductList';
import Categories from '../components/Categories';
import CountryService from '../services/CountryService';
import { Section, Title, Breadcrumbs } from '../modules/modules';
import SubCategory from '../components/SubCategory';
import Image from '../components/Image';
import Link from '../components/Link';
import { IBreadcrumbItem } from 'src/interfaces/IBreadCrumbItem';
import Helmet from 'react-helmet';
import { renderBreadCrumList as renderBreadCrumbListLDJSON } from '../helpers/ld_json';

const buildBreadcrumbs = (
  categoryId: string | undefined,
  values: Array<IBreadcrumbItem> = [],
  language: string,
  allCategories: Array<GQL.ICategory>,
): Array<IBreadcrumbItem> => {
  const { countryCode, currencyCodePageParam } = CountryService.GetInstance();

  if (categoryId == undefined) {
    // Country code urls are not used anymore
    // values.unshift({ value: '', link: `/${countryCode}` });
    values.unshift({ value: '', link: '/' });
    return values;
  }

  const category = allCategories.find(c => c.id == categoryId);
  if (category == undefined) {
    throw Error('I cant find category while building bredcrumbs');
  }

  values.unshift({
    value: category.name[language],
    // Country code urls are not used anymore
    // link: `/${countryCode}/products/${category != undefined &&
    link: `/products/${category != undefined &&
      category.slug != undefined &&
      category.slug[language]}${currencyCodePageParam ? `?currency=${currencyCodePageParam}` : ''}`,
  });

  const anotherCategoryId = category.parentCategoryId ? category.parentCategoryId : undefined;

  return buildBreadcrumbs(anotherCategoryId, values, language, allCategories);
};

interface IProductsProps extends RouteComponentProps<{ categoryChain: string; language: string }> {
  setCurrentProductAvailabityWatchdogForm?: (product?: GQL.IProduct, variant?: GQL.IProductVariant) => void;
}

interface IProductState {}

class Products extends React.Component<IProductsProps, IProductState> {
  public loading: boolean;
  public state: IProductState;

  constructor(props: IProductsProps) {
    super(props);
  }

  public render() {
    const { categoryChain } = this.props.match.params;
    const { language, countryCode, countryId } = CountryService.GetInstance();

    return (
      <GetCategoriesQuery>
        {({ categories }: any) => {
          if (categories && categories.categories) {
            const selectedCategory = categories.categories.find(
              (category: GQL.ICategory) => category.slug[language] === categoryChain,
            );

            // const categoryByTag = virtualizeCategories[this.props.match.params.categoryChain];

            const searchQuery = window && window.location && queryString.parse(window.location.search).q
              || !categoryChain && ' '.repeat(21)
              || undefined; // v SSR zlobilo, toto by mělo pomoct

            // kategorie neexistuje
            if (!selectedCategory && !searchQuery /* && !categoryByTag*/) {
              return <ErrorPage title={`Category not found`} />;
            }

            const breadCrumbs: IBreadcrumbItem[] = selectedCategory
              ? buildBreadcrumbs(selectedCategory.id, [], language, categories.categories)
              : [];

            return (
              <main>
                <Section type="products">
                  <div className="container">
                    {selectedCategory && (
                      <div className="row">
                        <div className="col-12">
                          <Breadcrumbs
                            links={breadCrumbs}
                          />
                          <Helmet>{renderBreadCrumbListLDJSON(breadCrumbs)}</Helmet>
                        </div>
                      </div>
                    )}

                    <div className="mainRow row">
                      <Categories selected={categoryChain} />
                      <div className="contentWrapper">
                        {selectedCategory && (
                          <>
                            <Title type="thin"><h1>{selectedCategory.longName && selectedCategory.longName[language] || selectedCategory.name[language]}</h1></Title>
                            {selectedCategory.banner && selectedCategory.banner[language] && (
                              <>
                                {selectedCategory.bannerLink[language] ? (
                                  <Link to={`/${countryCode}${selectedCategory.bannerLink[language]}`}>
                                    <Image
                                      className="category__banner"
                                      image={selectedCategory.banner[language]}
                                    />
                                  </Link>
                                ) : (
                                  <Image
                                    className="category__banner"
                                    image={selectedCategory.banner[language]}
                                  />
                                )}
                              </>
                            )}
                            {selectedCategory.description && selectedCategory.description[language] && (
                              <div
                                className="category__description"
                                dangerouslySetInnerHTML={{ __html: selectedCategory.description[language] }}
                              />
                            )}
                          </>
                        )}

                        {searchQuery && (
                          <Title type="search">
                            <span className="search__title">Search:</span>
                            <span className="search__quotemark">„</span>
                            <span className="search__string">{searchQuery}</span>
                            <span className="search__quotemark">“</span>
                          </Title>
                        )}

                        <SubCategory selected={selectedCategory} categories={categories.categories} />
                        <ProductList
                          language={language}
                          country={countryId || undefined}
                          search={searchQuery}
                          category={selectedCategory}
                          categoryByTag={''}
                          setCurrentProductAvailabityWatchdogForm={
                            this.props.setCurrentProductAvailabityWatchdogForm
                          }
                        />
                      </div>
                    </div>
                  </div>
                </Section>
              </main>
            );
          }

          return null;
        }}
      </GetCategoriesQuery>
    );

    // return (<div>
    //   {banner &&
    //     <Message to={banner.link}>{banner.title[language]}</Message>}

    //   <Categories>
    //     {({ categories }: any) => {
    //       if (categories.loading || categories.categories == undefined) {
    //         return (
    //           <React.Fragment>
    //             <Placeholder type="productListHead"/>
    //             <Placeholder type="productListFilters"/>
    //             <Placeholder type="products"/>
    //           </React.Fragment>
    //         );
    //       }

    //       const categoryByTag = virtualizeCategories[this.props.match.params.categoryChain];

    //       const searchQuery = window && window.location && queryString.parse(window.location.search).q;

    //       const category = findCategory(
    //         categories.categories,
    //         this.props.match.params.categoryChain,
    //         language
    //       ) as any;

    //       // kategorie neexistuje
    //       if (!category && !searchQuery && !categoryByTag) {
    //         return (<ErrorPage title={`Hledaná kategorie neexistuje`} />);
    //       }

    //       return (
    //         <div>
    //           <React.Fragment>
    //             {category && (
    //               <React.Fragment>
    //                 <Title El="h1" type="productList">
    //                   {category.name[ language ]}
    //                 </Title>
    //                 <Breadcrumbs
    //                   links={buildBreadcrumbs(category.id, categories.categories, [], language)}
    //                   type="noSpacing"
    //                 />
    //               </React.Fragment>
    //             )}

    //             {categoryByTag && (
    //               <React.Fragment>
    //                 <Title El="h1" type="productList">
    //                   {categoryByTag.title[ language ]}
    //                 </Title>
    //                 <Breadcrumbs
    //                   links={buildBreadcrumbs('', categories.categories, [], language)}
    //                   type="noSpacing"
    //                 />
    //               </React.Fragment>
    //             )}

    //             {searchQuery && (
    //               <Title type="search">
    //                 <span className="search__title">Vyhledáváno:</span>
    //                 <span className="search__quotemark">„</span>
    //                 <span className="search__string">{searchQuery}</span>
    //                 <span className="search__quotemark">“</span>
    //               </Title>
    //             )}
    //           </React.Fragment>

    //           <ProductList
    //             language={language}
    //             search={searchQuery}
    //             category={category}
    //             categoryByTag={categoryByTag ? categoryByTag.tag : undefined}
    //           />
    //         </div>
    //       );
    //     }}
    //   </Categories>
    //   <Services />
    //   {/* <Stores /> */}
    //   </div>
    // );
  }
}

export default withRouter(Products);



// WEBPACK FOOTER //
// ./src/pages/Products.tsx